import { Alert as MuiAlert, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export type EVariant = 'error' | 'success' | 'warning' | 'info';

interface IProps {
  severity: EVariant;
  message: string;
  className?: string;
  onClose?: ((event: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined;
}

function Alert(props: IProps) {
  const { className, message, onClose, severity } = props;

  return (
    <Box className={className} sx={{ mb: 2 }}>
      <MuiAlert
        severity={severity}
        action={
          onClose && (
            <IconButton aria-label="Close" color="inherit" size="small" onClick={onClose}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          )
        }
      >
        {message}
      </MuiAlert>
    </Box>
  );
}

export default Alert;
